// extracted by mini-css-extract-plugin
export default {"cardContainer":"AddFolder_cardContainer__MGmfM","header":"AddFolder_header__VHfFX","body":"AddFolder_body__eW5Ih","actions":"AddFolder_actions__nSU0S"};